import {
  getBfpQuizQuestions,
  getBfpQuizSubbuzzes,
  shouldRenderShoppingCarousel,
  isTagYourselfExperiment,
  QUESTION_TYPE_SCALE,
  QUESTION_TYPE_TAP_ON_IMAGE,
} from './cardStyleQuizExperiment';

export const isCardStyleQuizAdInjectionExperimentEligible = buzz => {
  if (!buzz?.isPersonality && !(buzz?.isTrivia && !buzz?.isTimedTrivia)) {
    return false;
  }

  if (!buzz?.isUS) {
    return false;
  }

  if ((buzz?.bfpFormats || []).some(format => format === 'scale_quiz' || format === 'tap_on_image')) {
    return false;
  }

  const questions = getBfpQuizQuestions(buzz);
  if (questions.some(question =>
    question?.type === QUESTION_TYPE_SCALE ||
    question?.type === QUESTION_TYPE_TAP_ON_IMAGE ||
    question?.multiselect
  )) {
    return false;
  }

  if (getBfpQuizSubbuzzes(buzz).some(subbuzz => subbuzz?.bfp_data?.data?.question_flow_control)) {
    return false;
  }

  const params = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search)
    : null;

  if (isTagYourselfExperiment(buzz) || params?.has('tag_yourself')) {
    return false;
  }

  if (shouldRenderShoppingCarousel(buzz)) {
    return false;
  }

  return true;
};
